import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-camera-tick-icon]',
  template: `
    <svg:path
      d="M6 3.5C6 2.11929 7.11929 1 8.5 1H15.5C16.8807 1 18 2.11929 18 3.5C18 3.77614 18.2239 4 18.5 4H20C21.6569 4 23 5.34315 23 7V12C23 12.5523 22.5523 13 22 13C21.4477 13 21 12.5523 21 12V7C21 6.44771 20.5523 6 20 6H18.5C17.1193 6 16 4.88071 16 3.5C16 3.22386 15.7761 3 15.5 3H8.5C8.22386 3 8 3.22386 8 3.5C8 4.88071 6.88071 6 5.5 6H4C3.44772 6 3 6.44772 3 7V19C3 19.5523 3.44772 20 4 20H12C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22H4C2.34315 22 1 20.6569 1 19V7C1 5.34315 2.34315 4 4 4H5.5C5.77614 4 6 3.77614 6 3.5ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12ZM22.7071 15.7929C23.0976 16.1834 23.0976 16.8166 22.7071 17.2071L18.2071 21.7071C17.8166 22.0976 17.1834 22.0976 16.7929 21.7071L14.7929 19.7071C14.4024 19.3166 14.4024 18.6834 14.7929 18.2929C15.1834 17.9024 15.8166 17.9024 16.2071 18.2929L17.5 19.5858L21.2929 15.7929C21.6834 15.4024 22.3166 15.4024 22.7071 15.7929Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CameraTickIcon {
  readonly viewBox = input<string>('0 0 24 24');
}
